import axios from "axios";

export async function updateProfile({ commit }, dataProfile) {
  try {
    const data = await axios.post(`user/update-user`, dataProfile);
    return data;
  } catch (e) {
    return e;
  }
}
